import { companyBrandingState } from '../state/companyBrandingState';
import { ADD_PASSWORD, PASSWORD_REQUEST, ADD_COMPANY_REQUEST, APPLICATION_REQUEST } from '../action/companyBrandingAction';


export function CompanyBrandingReducer(state = companyBrandingState, action) {
    switch (action.type) {
        case ADD_COMPANY_REQUEST:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: false,
                Message: 'Success',
                brandList: action.brandList
            })
        case APPLICATION_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message: ''
            })
        case ADD_PASSWORD:
            return Object.assign({}, state, {
                errorCode: action.errorCode,
                statusCode: action.statusCode,
                isLoading: false,
                Message: 'Success',
                passwordData: action.passwordData
            })
        case PASSWORD_REQUEST:
            return Object.assign({}, state, {
                errorCode: 0,
                statusCode: 0,
                isLoading: action.isLoading,
                Message: ''
            })
        default:
            return state
    }
}